import qs from 'qs'

const aiModelsRequests = {
  addAiModelRequest: (data) => ({
    url: `api/ai/models`,
    method: 'post',
    data,
  }),
  updateAiModelRequest: (data) => ({
    url: `api/ai/models`,
    method: 'put',
    data,
  }),
  searchAiModelsRequest: ({ searchText, skip = 0, take = 50, attached = true, aiObjectsIds = [] }) => ({
    url: `api/ai/models`,
    method: 'get',
    params: {
      attached,
      aiObjectsIds,
      search: searchText,
      skip,
      take,
    },
    paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat' }),
  }),
  getUnattachedAiModelsRequest: ({ filters = {}, pageNumber = 1, pageSize = 25 }) => ({
    url: `api/ai/models/unattached`,
    method: 'get',
    params: {
      ...filters,
      skip: (pageNumber - 1) * pageSize,
      take: pageSize,
    },
  }),
  publishAiModelRequest: ({ aiModelId, tenants }) => ({
    url: `api/ai/models/${aiModelId}/publish`,
    method: 'post',
    data: {
      TenantIds: tenants.map((tenant) => tenant.Id),
    },
  }),
  unpublishAiModelRequest: ({ aiModelId, tenants }) => ({
    url: `api/ai/models/${aiModelId}/unpublish`,
    method: 'post',
    data: {
      TenantIds: tenants.map((tenant) => tenant.Id),
    },
  }),
}

export default aiModelsRequests
